import React, { useRef, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import store, { RootState, AppDispatch } from '../../../store/store';
import { setButtonActive } from '../../../store/stream/stream-slice';
import { setIsSkipped, setIsStreamingLoading, setMicroButton } from '../../../store/chat/chat-slice';
import { getIsSkipped, getIsStreamingLoading, getMicroButton } from 'store/chat/chat-selectors';
import { getIsClicked, getIsOverlayVisible, getIsStartVolume } from '../../../store/stream/stream-selectors';
import BackButton from '../../shared/BackButton/BackButton';



const VideoWrapper: React.FC = () => {
  const startVideoRef = useRef<HTMLVideoElement | null>(null);
  const bodyVideoRef = useRef<HTMLVideoElement | null>(null);
  const talkVideoRef = useRef<HTMLVideoElement | null>(null); // Видео для стрима
  const dispatch: AppDispatch = useDispatch();
  const isVolume = useSelector((state: RootState) => state.stream.isStartVolume);
  const isStreaming = useSelector((state: RootState) => state.stream.isStreaming);
const isOverlayVisible = useSelector(getIsOverlayVisible)
  const [isStreamPlaying, setIsStreamPlaying] = useState(false); // Показ стрима
  const [isTalkVideoActive, setIsTalkVideoActive] = useState(false); // Состояние для активации talk-video
  const isSkipped = useSelector(getIsSkipped);
  const isStartVolume = useSelector(getIsStartVolume);
  const isClicked = useSelector(getIsClicked);
  const microButton = useSelector(getMicroButton);
  const effectTriggeredRef = useRef(false);
  useEffect(() => {
    if (startVideoRef.current && isVolume) {
        startVideoRef.current.play();
    }
  }, [isVolume]);

  useEffect(() => {
    if (startVideoRef.current && isSkipped) {
      startVideoRef.current.pause();
      effectTriggeredRef.current = true; // Устанавливаем флаг через useRef
      handleVideoEnd();
    }
  }, [isSkipped]);

// Обработчик окончания воспроизведения стартового видео
  const handleVideoEnd = () => {
    if (bodyVideoRef.current) {
      bodyVideoRef.current.classList.remove('hidden');
      bodyVideoRef.current.play();
    }
    if (startVideoRef.current) {
      startVideoRef.current.classList.add('hidden');

      // Всегда устанавливаем задержку 6 секунд перед скрытием loading
      setTimeout(() => {
        dispatch(setIsStreamingLoading(false));
      }, 6000);

      dispatch(setIsSkipped(true));
      dispatch(setMicroButton(true));
      dispatch(setButtonActive(false));
    }
  };

  // Обработчик окончания стрима (talk-video)
  const handleTalkVideoEnd = () => {
    setIsStreamPlaying(false); // Отключаем флаг стрима
    setIsTalkVideoActive(false); // Деактивируем класс active для стрим видео

    // Возвращаем основное видео
    if (bodyVideoRef.current) {
      bodyVideoRef.current.play();
    }
  };

  useEffect(() => {
    const currentIsReload = store.getState().chat.isReload;
    if (isStreaming && talkVideoRef.current && !currentIsReload) {
      setIsStreamPlaying(true); // Включаем стрим

      // Ожидаем завершения основного видео с задержкой, чтобы плавно перейти к стриму
      setTimeout(() => {
        if (bodyVideoRef.current) {
          bodyVideoRef.current.pause(); // Останавливаем основное видео
        }

        // Включаем видео стрима через 3 секунды
        setIsTalkVideoActive(true);
        if (talkVideoRef.current) {
          talkVideoRef.current.play();
        }
      }, 2400); // Задержка 3 секунды перед стримом
    } else if (!isStreaming && isStreamPlaying) {
      // Если стрим завершен
      setIsStreamPlaying(false);
      setIsTalkVideoActive(false); // Деактивируем talk-video

      // Восстанавливаем воспроизведение основного видео
      if (bodyVideoRef.current) {
        bodyVideoRef.current.play();
      }
    }
  }, [isStreaming]);


  useEffect(() => {
    if (startVideoRef.current) {
      startVideoRef.current.addEventListener('ended', handleVideoEnd);
    }

    if (talkVideoRef.current) {
      talkVideoRef.current.addEventListener('ended', handleTalkVideoEnd); // Обработчик окончания стрима
    }

    return () => {
      // Удаляем обработчики при размонтировании
      if (startVideoRef.current) {
        startVideoRef.current.removeEventListener('ended', handleVideoEnd);
      }
      if (talkVideoRef.current) {
        talkVideoRef.current.removeEventListener('ended', handleTalkVideoEnd);
      }
    };
  }, []);

  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 1024);
  useEffect(() => {
    const handleResize = () => setIsSmallScreen(window.innerWidth < 1024);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div
      id="video-wrapper"
      className={!isStartVolume ? `video-wrapper skeleton` : 'video-wrapper'}
    >
      {!isSmallScreen ?
        <BackButton
        href="https://gipotireoz.ru/"
        altText="External link"
        skeleton={`${!isStartVolume ? 'skeleton' : ''}`}
      />
        : ''}

      {!isSmallScreen && (
        <div className={`${!isStartVolume ? 'skeleton merk' : 'merk'}`}>
          <div className="merkImg"></div>
        </div>
      )}

      <div className="skeleton" style={isStartVolume ? { display: 'none' } : {}}></div>

      <video
        id="talk-video"
        className={`${isTalkVideoActive ? 'talk-video active' : 'talk-video'} ${!isStartVolume ? 'skeleton' : ''}`}
        ref={talkVideoRef}
        playsInline
      ></video>
      <video
        id="start-video"
        className={`start-video ${!isStartVolume ? 'skeleton' : ''}`}
        ref={startVideoRef}
        src="videos/hello11.mp4"
        playsInline
      ></video>
      <video
        id="video-body"
        className={`video-body ${isStreaming ? 'hidden' : ''} ${!isStartVolume ? 'skeleton' : ''}`}
        ref={bodyVideoRef}
        src="videos/body.mp4"
        autoPlay
        muted
        loop
        playsInline
      ></video>
    </div>
  );
};

export default VideoWrapper;
